<script setup lang="ts">
import { useAuthStore } from '../../stores/authStore'
import { onMounted, shallowRef, defineAsyncComponent } from 'vue'
import type { Component } from '#imports'

const authStore = useAuthStore()
const adminThings = shallowRef<Component>()
onMounted(async () => {
  if (authStore.authorized) {
    adminThings.value = defineAsyncComponent(() => import('~/layers/cms/app/components/cms/admin/adminThings.vue'))
  }
})
</script>

<template>
  <component
    :is="adminThings"
    v-if="adminThings"
  />
</template>
